module.exports = __webpack_public_path__ + "static/media/MenubarLogo.7f77e306.png";